export default __webpack_public_path__ + "static/O0160-947220faceb1a4c03aa74347e4c34ca5.png";